export const DEFAULT_CONFIRM_TITLE = 'Save changes?';
export const DEFAULT_CONFIRM_MESSAGE =
    'Are you sure you want to save these changes? This will update your configuration.';
